export default {
    firstname: 'given-name',
    infixname: 'additional-name',
    surname: 'family-name',
    zipcode: 'postal-code',
    house_num: 'off',
    house_num_add: 'off',
    telephone: 'tel',
    emailaddress: 'email'
};



// WEBPACK FOOTER //
// ./src/app/config/autocompletes.js